module.exports = __webpack_public_path__ + "imgs/f74fdd1c93811cceca0c83128300b8a6.jpg";